import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './css/tailwind-init.css';
import 'react-toastify/dist/ReactToastify.css';
import './assets/fonts/vazirmatn/base.css';
import 'rsuite/dist/rsuite.min.css';
import './css/colors.css';
import './css/index.css';
import './css/tailwind.css';
import './css/datepicker.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
